// extracted by mini-css-extract-plugin
module.exports = {"card":"WgwZgo6F"};